import React from 'react';
import { Input, CnIcon } from '@alife/cn-ui';
import './index.scss';
import { useI18n } from '@alife/panda-i18n';
import { useInputOnSearch } from 'src/hooks';
export default (props) => {
    const { onChange, className, ...rest } = props;
    const $i18n = useI18n();
    const inputEvents = useInputOnSearch(onChange);
    return (React.createElement("div", { className: `cn-intelli-assistant-search ${className}` },
        React.createElement(Input, { className: `cn-intelli-assistant-search-input ${rest.readOnly ? 'can-click' : ''}`, placeholder: $i18n.get({
                id: 'PleaseEnterTheQuestionKeywordSearch_1848556372',
                dm: '请输入问题关键词搜索',
            }), innerBefore: React.createElement(CnIcon, { type: 'search', className: 'cn-intelli-assistant-search-input-icon' }), size: 'medium', ...rest, ...inputEvents })));
};
